import 'core-js';
import Vue from 'vue';
// 引入 css
import './lib/css/reset.css';
// 引入 dpub 组件库，文档参考 https://git.xiaojukeji.com/agility-fe/dpub-widget-thanos ，联系人 xiachenghao
import View from '@didi/thanos-components/src/components/View/index.vue';
import dpubWidget from '@didi/dpub-widget-thanos/lib/PriceTable/h5';
import '@didi/dpub-widget-thanos/lib/PriceTable/h5/index.css';
import { genRenderFnForH5 } from '@didi/dpub-render';
import DsCenter from '@didi/xpub-client-sdk'
import { getShareData } from './lib/js/set-aio-share';
import getData from './lib/js/initData';
import agility from './lib/js/utils';
import * as eventActions from './lib/js/event/index';
import omegaSet from './lib/js/omegaSet'
import { store, initPageData } from './lib/js/store/index'
import fn from './lib/js/store/exposeApi'

window._store = store
window.fn = fn
Vue.component('th-view', View);
Vue.use(dpubWidget);

function initDsCenter(res) {
    const { scenes } = res
    if (scenes.dsTableList) scenes.dsList = scenes.dsTableList
    if (scenes.dsTable && scenes.dsList) {
        const dsCenter = new DsCenter({
            dsTable: scenes.dsTable,
            dy_dsList: scenes.dsList,
            setProps: (wid, data) => {
                console.log('hihihihi', wid, data)
                fn.setWidgetProps(wid, data)
            }
        })
        window.dsCenter = dsCenter
        console.log(dsCenter)
        return dsCenter
    }
    console.log('no dstable', scenes)
}
// console.log('NODE_ENV', process.env.NODE_ENV)
// 准备渲染数据。开发环境下返回 mock 数据，生产环境将替换真实数据。
getData().then((res) => {
    window.SCENES = res.scenes;
    window.GLOBAL_DATA = res.global;
    window.PROJECT_ID = res.id;
    window.BUSINESS_DATA = res.businessData;
    // 设置 aio
    window.__DATA__ = {};

    initPageData(res)
    const dsCenter = initDsCenter(res)
    if (dsCenter) {
        dsCenter.dataSource.fetchInitialReq()
    }
    // 统计配置
    omegaSet.init()
    // 设置分享
    const global = window.GLOBAL_DATA || {};
    const shareData = getShareData(global.share);
    // 挂载分享信息到window上，AIO 在微信中拉起分享时需要
    window.__DATA__.shareData = shareData;

    if (global.canShare) {
        window.D.setShare(shareData);
    } else {
    // 关闭分享...
        window.D.setShare(false);
    }
    // 设置登录
    window.D.setLoginConfig({
        loginType: 'trinity',
    });
    window.__EVENT_ACTIONS = eventActions;
    agility.setTitle(res.title);
    // eslint-disable-next-line
    new Vue({
        el: '#app',
        store,
        render: h => genRenderFnForH5(store.state.page, dpubWidget)(h),
    });
});
